import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change, Form, SubmissionError } from 'redux-form';
import uuid from 'uuid/v1';
import moment from 'moment';

import { SCHEDULE_DAYS } from 'pages/create-activity/constants';

import {
  CustomDateRangePicker,
  MultiDatePickerCalendar,
  PopoverWrapper,
  DropDown,
  Input,
  CheckboxButtonsGroup,
  FormActionButtons
} from 'components';

import validate from './validate';

import HelpIcon from '@material-ui/icons/Help';

import { useStyles } from './styles';

const initialValues = {
  availability: {
    startDate: moment(),
    endDate: null
  },
  days: SCHEDULE_DAYS,
  cutoffPeriod: 0,
  cutoffPeriodTimeType: 'days'
};

const ScheduleDate = ({
  onSubmit,
  handleSubmit,
  getPricesData,
  setSubmitButton,
  isUpdate,
  ...props
}) => {
  const classes = useStyles();

  const { pricesDailyForm, changeFieldValue } = props;

  const getFormCategoriesByDayName = day => {
    const existedDay = pricesDailyForm.values.days.find(
      item => item.day === day
    );

    if (existedDay) return existedDay.categories;

    return [
      {
        participant: 'Adult',
        USD: '0',
        EUR: '0',
        NOK: '0'
      }
    ];
  };

  const submit = values => {
    const errors = validate(values);

    if (Object.keys(errors).length) {
      throw new SubmissionError(errors);
    }

    const days = values.days;

    const newDaysArray = Object.keys(days)
      .filter(key => days[key])
      .map(field => ({
        id: uuid(),
        day: field,
        categories: getFormCategoriesByDayName(field)
      }));

    const fixedPricesDays = newDaysArray.map(item => {
      const categories = item.categories;
      return {
        id: uuid(),
        days: [item.day],
        USD: (categories && categories[0]['USD']) || '0',
        EUR: (categories && categories[0]['EUR']) || '0',
        NOK: (categories && categories[0]['NOK']) || '0'
      };
    });

    changeFieldValue('pricesFixedForm', 'days', fixedPricesDays);
    changeFieldValue('pricesDailyForm', 'days', newDaysArray);
    getPricesData({
      days: newDaysArray
    });

    onSubmit(values);
  };

  return (
    <div>
      <Form onSubmit={handleSubmit(submit)}>
        <div className={classes.row}>
          <div className={classes.column}>
            <div className={classes.datePickerWrapper} >
              <Field
                name="availability"
                label="Availability"
                component={CustomDateRangePicker || MultiDatePickerCalendar}
              />
            </div>
            <PopoverWrapper text="If you don't select the timestamps, the activity will be available all the time">
              <HelpIcon className={classes.helpIcon} />
            </PopoverWrapper>
          </div>
          <div className={classes.column}>
            <div className={classes.cutOffField}>
              <div className={classes.cutOffFieldWrapper}>
                <Field
                  name="cutoffPeriod"
                  isOnlyNumber={true}
                  maxLength={9}
                  placeholder="Number"
                  label="Cutoff period"
                  component={Input}
                />
              </div>

              <PopoverWrapper text="Cutoff period info sign">
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            </div>

            <div className={classes.cutOffTypeField}>
              <Field
                name="cutoffPeriodTimeType"
                list={['minutes', 'hours', 'days', 'weeks']}
                component={DropDown}
              />
            </div>
          </div>
        </div>

        <Field className={classes.row}
          name="days"
          title="Select Days *"
          component={CheckboxButtonsGroup}
        />
        <div className={classes.divider}>{''}</div>
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </Form>
    </div>
  );
};

const mapStateToProps = state => ({
  pricesDailyForm: state.form.pricesDailyForm
});

const mapDispatchToProps = dispatch => ({
  changeFieldValue: (form, field, value) => {
    dispatch(change(form, field, value));
  }
});

export default reduxForm({
  form: 'scheduleDateForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(ScheduleDate));
